var _defs, _path, _path2, _path3, _path4, _path5, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 571.4 555.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#ff4404;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 300.2,
    y1: 364.99,
    x2: 710.06,
    y2: 556.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1179.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#55abed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5da6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4404"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 553.62,
    y1: 601.85,
    x2: 795.27,
    y2: 631.52,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1179.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55abed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#60a4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8a8ba5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ad7574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#cb644c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e2562c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f24c16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fc4609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ff4404"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 506.2,
    y1: 673.59,
    x2: 586.59,
    y2: 673.59,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1179.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#55abed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5da6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#64a2d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7896be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#978392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#c36856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fa470b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4404"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.5,717.2c-36.1-9.4-60.1-31-74.5-63.4-4.6-10.3-6.6-21.1-6.5-33.4,4.7,2.7,8.7,4.9,12.6,7.2,39.6,23,81.9,36.1,128,34.4,33.3-1.2,64.3-9.9,91.1-30.6,2.7-2.1,4-1.6,5.7,1.3,13.7,22.7,31.9,40.8,56,52.4,21.1,10.2,43.5,13.5,66.9,11.1a117.42,117.42,0,0,0,45.3-14c.9-.5,1.8-.9,2.7-1.3a10.18,10.18,0,0,1,1.9,0c-1,6.1-1.8,12.1-3,17.9-7.2,35.2-21.2,67.2-44.2,95.1-16.3,19.7-36,35.4-58.2,48-32.4,18.3-67.4,28.6-104.2,33.2-55.7,6.9-110.3,2.7-163.7-15.1-17.7-5.9-34.7-13.5-50.4-23.9-1.3-.9-2.5-1.9-4.5-3.4,47.9,2.6,91.9-7.3,132.6-30.8,5-2.9,9.4-7,13.9-11.1-44.1-4.6-73.6-28-91.8-67.4C377.7,721.9,392.5,725,407.5,717.2Z",
    transform: "translate(-308.5 -323)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M584.2,477.9a119.65,119.65,0,0,1,93.7-42.6c3.5.1,6.5,0,7.4,5.1,1.1,5.8,12.4,7.5,16.9,2.5,2.8-3.1,5.1-2.8,8.3-1.7,44.9,15.9,72.8,47.7,82.5,93.7,11.1,52.8-4.6,97.9-47.3,131.4-43.5,34.2-102.3,32.5-145.4-2.5-25.8-21-41.3-48.2-46.1-81.2-1.2-8.3-1.3-16.8-1.9-25.3-.2-3.1,1-5.2,4.3-5.5,9.2-.9,14-6.8,17.6-14.7a302.57,302.57,0,0,1,14.6-28.3c5.3-8.7,3.4-16.5-.9-24.5C586.9,482.4,585.7,480.4,584.2,477.9Zm61.5,25.8A31.2,31.2,0,0,0,614.2,535a31.55,31.55,0,1,0,31.5-31.3Zm107.8,71.6a27.64,27.64,0,0,0,27.9-27.8c0-15.1-12.2-28.1-26.6-28.3-16.5-.2-29.2,12.1-29.2,28.2A27.6,27.6,0,0,0,753.5,575.3Zm-69.3,80.2c15.8-.3,28-5.8,39.3-13.4,2.6-1.8,4.5-5.2,5.7-8.3.6-1.4-.8-4.2-2.1-5.5-.8-.8-3.4-.4-5,.2-2.2.8-4.1,2.2-6.2,3.2-15.8,7.5-31.9,11.3-47.9,1.1-5.7-3.6-10.4-8.7-15.5-13.1-2.2-2-4.3-4.7-7.7-2.6s-5.1,5.4-3,9c2.9,4.9,6,9.9,10.1,13.9C661.4,649,672.3,655.4,684.2,655.5Z",
    transform: "translate(-308.5 -323)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M512,526.3c9,16.6,29.6,25.7,48.5,18.3A11.26,11.26,0,0,0,566,540c6.8-12.6,13.3-25.3,19.6-38.1a10.06,10.06,0,0,0,.7-6.6c-5.6-19.8-26.6-33.2-46.4-29.2-18.4,3.7-33.7,21.4-33.7,39.8C506.2,506,506.6,518.6,512,526.3Z",
    transform: "translate(-308.5 -323)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M826,353c-18.6.8-37.3,1.5-55.9,1.8-6.9.1-11.7,2.3-15.8,8.2-16.7,24.1-34,47.8-51,71.6-4.8,6.8-8,7.8-13.2,4.2a.44.44,0,0,1-.1-.5c1.4-2.1,2.7-4.2,4.1-6.2q29.1-40.35,58.3-80.6c2.3-3.2,4.8-4.3,8.7-4.4,18.2-.4,36.3-1.2,54.5-1.8,5.1-.2,11.7-2.4,11.6,7.6",
    transform: "translate(-308.5 -323)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M801,558.4a145.75,145.75,0,0,0-17-61.6c9.7-1.1,17.6,1.1,24.4,6.5,10.1,8.1,14.1,18.7,11.7,31.5C818.1,545.6,812,553.4,801,558.4Z",
    transform: "translate(-308.5 -323)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 545.7,
    cy: 25.7,
    r: 25.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b2cc1203ef62e43ada2cdff3d3c2c3ea.svg";
export { ForwardRef as ReactComponent };